module.exports = __webpack_public_path__ + "img/lead-climbing.20c76838.svg";